import lockIconSrc from '@corbado/shared-ui/assets/lock.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const LockIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, lockIconSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'lock-icon', ...props }));
});
